import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useSelector } from "react-redux";

import CommentOption from "../CommentOption";
import CustomAvatar from "../../CustomAvatar";
import { getSettingState } from "../../../../redux/features/settingSlice";
import moment from "moment/moment";
import Replayed from "./../../Replayed/index";
import CommentReplayed from "./../../CommentReplayed";
import RightLeftChecker from "../../../../utils/RightLeftChecker";
import { useLocation } from "react-router";

const CommentCard = ({ cmData, firstIndex, lastIndex }) => {
  const theme = useTheme();
  const { userData } = useSelector(getSettingState);
  const myComment = userData === cmData.author.id;
  const location = useLocation();
  let urlParams = location.pathname.split("/");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        backgroundColor: theme.palette.white.main,
        fontSize: "10px",
        margin: "0px 16px 0px 18px",
      }}
    >
      {!myComment && (
        <Box sx={{ mb: "10px", mr: "8px" }}>
          {firstIndex ? (
            <CustomAvatar
              link={`/profile/${cmData.author.username}`}
              borderSize={2}
              size={"46px"}
              src={cmData.author.avatar}
              alt={cmData.author.nickname}
            />
          ) : (
            <Box sx={{ width: "50px" }} />
          )}
        </Box>
      )}

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: myComment ? "flex-end" : "flex-start",
          minWidth: "225px",
        }}
      >
        <Box
          sx={{
            border: "2px solid",
            borderRadius: myComment
              ? `16px ${lastIndex ? "16px" : "8px"} 8px 16px`
              : `${lastIndex ? "16px" : "8px"} 16px 16px 8px`,
            padding: "16px 16px 12px 16px",
            width: myComment ? "83%" : "92%",
            mt: "4px",
            mb: "4px",
            backgroundColor: myComment ? "#EEEEEE" : "white.main",
          }}
        >
          <CommentOption cmData={cmData}>
            {lastIndex && (
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: 600,
                  fontSize: "14px",
                  paddingBottom: "4px",
                }}
              >
                {cmData.author.nickname}
              </Typography>
            )}
            {cmData.content_data && urlParams[3] === "comment" && (
              <CommentReplayed cmData={cmData} />
            )}
            {cmData.is_reply && <Replayed cmData={cmData} />}
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                color: myComment ? "#212121" : "black.main",
                pt: "4px",
                overflowY: "hidden",
                overflowX: "scroll",
                textOverflow: "ellipsis",
                whiteSpace: "pre-line",
                direction: RightLeftChecker(cmData.text) ? "rtl" : "ltr",
                wordWrap: "break-word",
              }}
            >
              {cmData.text}
            </Typography>
            <Typography
              sx={{
                fontSize: "11px",
                textAlign: "right",
                color: "#757575",
                textTransform: "uppercase",
                mb: "-3px",
              }}
            >
              {moment(cmData.created_at).format("h:mm a")}
            </Typography>
          </CommentOption>
        </Box>
      </Box>
    </Box>
  );
};

export default CommentCard;
